import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  formDataPost,
  formDataPut,
  patch,
  post,
  put,
  get,
} from "helpers/api_helper"
import {
  GET_ALL_ORDERS,
  GET_ORDER_DETAILS,
  ORDER_STATUS_UPDATE,
  SYNC_ORDER_WITH_POS,
} from "helpers/url_helper"

export const getAllOrders = createAsyncThunk(GET_ALL_ORDERS, async payload => {
  const response = await post(GET_ALL_ORDERS, payload)
  return response
})

export const getOrderDetails = createAsyncThunk(GET_ORDER_DETAILS, async id => {
  const response = await get(`${GET_ORDER_DETAILS}/${id}`)
  return response
})

export const updateOrderStatus = createAsyncThunk(
  ORDER_STATUS_UPDATE,
  async payload => {
    const response = await patch(ORDER_STATUS_UPDATE, payload)
    return response
  }
)

export const syncOrderWithPos = createAsyncThunk(
  SYNC_ORDER_WITH_POS,
  async payload => {
    const response = await post(SYNC_ORDER_WITH_POS, payload)
    return response
  }
)
